/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";

const useAttendenceService = ({ openSnackbar, selectedMonth,selectedYear }) => {
    const [year, setYear] = useState('');
    const [monthOptions, setMonthOptions] = useState([]);
    const [count, setCount] = useState(0)
    const [yearOptions, setYearOptions] = useState([]);
    const [errorMessage, setErorMessage] = useState()
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [attendanceSummeryLists, setAttendanceSummeryLists] = useState([])
    const [isApproved, setIsApproved] = useState(true)
    const [isViewButton, setIsViewButton] = useState()
    const { fetchData } = useAPIHandler();

    async function getEmployeeData(month, year) {
        const daysInMonth = new Date(year, month, 0).getDate();
        const randomDay = Math.floor(Math.random() * daysInMonth) + 1;
        const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(randomDay).padStart(2, '0')}`;

        logger.log(`Generated Random Date: ${formattedDate}`);

        const URL = `/attendance/export-attendance?date=${formattedDate}`;
        const METHOD = "GET";
        try {
            const result = await fetchData({
                url: URL,
                method: METHOD,
            });

            if (result?.status === "success" && result?.data) {
                return result?.data
            }
        } catch (error) {
            setErorMessage(error.message)
            logger.log(error, "dipronil")
        }
    }

    function exportToCSV(attendanceData) {
        if (!attendanceData || !attendanceData.columns || !attendanceData.data) {
            console.error("Invalid attendance data for CSV export.");
            return;
        }
        const headers = attendanceData.columns.map((col) => col.header);
        const headerKeys = attendanceData.columns.map((col) => col.key);
        logger.log(headers, "dipronil")
        const rows = attendanceData.data.map((row) =>
            headerKeys.map((key) => row[key.toLowerCase()] || "")
        );

        const csvContent = [
            headers.join(","),
            ...rows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = `attendance_${new Date().toISOString().split("T")[0]}.csv`;
        link.click();

        URL.revokeObjectURL(url);
    }


    const handleChoosenMonth = (e, dateOfOrg) => {
        const selectedYear = e;
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;

        const orgDate = new Date(dateOfOrg);
        const orgYear = orgDate.getUTCFullYear();
        const orgMonth = orgDate.getUTCMonth() + 1;

        setYear(selectedYear);

        if (selectedYear === currentYear.toString()) {
            setMonthOptions(
                Array.from({ length: currentMonth }, (_, i) => ({
                    id: (i + 1).toString(),
                    name: new Date(0, i).toLocaleString('default', { month: 'long' }),
                }))
            );
        } else if (selectedYear > currentYear) {
            setMonthOptions([{ id: "1", name: "January" }]);
        } else if (selectedYear === orgYear.toString()) {
            setMonthOptions(
                Array.from({ length: 12 - orgMonth + 1 }, (_, i) => ({
                    id: (orgMonth + i).toString(),
                    name: new Date(0, orgMonth + i - 1).toLocaleString('default', { month: 'long' }),
                }))
            );
        } else {
            setMonthOptions(
                Array.from({ length: 12 }, (_, i) => ({
                    id: (i + 1).toString(),
                    name: new Date(0, i).toLocaleString('default', { month: 'long' }),
                }))
            );
        }
    };


    const handleChoosenYear = (dateOfOrg) => {
        const currentYear = new Date().getUTCFullYear();
        let startYear;

        // If dateOfOrg is null or invalid, set startYear to last 20 years
        if (!dateOfOrg || isNaN(new Date(dateOfOrg).getTime())) {
            startYear = currentYear - 20;
        } else {
            startYear = new Date(dateOfOrg).getUTCFullYear();
        }

        const yearList = [];
        for (let year = startYear; year <= currentYear; year++) {
            yearList.push({ id: year.toString(), name: year.toString() });
        }

        setYearOptions(yearList.reverse());
    };

    const uploadCSVData = async (file, month, year) => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('month', month);
            formData.append('year', year);

            const URL = `/attendance/import-attendance`;
            const METHOD = "POST";

            const result = await fetchData({
                url: URL,
                method: METHOD,
                data: formData,
            });

            if (result?.status === "success" && result?.data) {
                // setAttendanceSummeryLists(result.data)
                getAttendenceSummeryLists(month, year)
                return result?.data
            }

        } catch (error) {
            if (error?.details?.status === "success" && error?.details?.data) {

                return error?.details?.data
            }
        }
    }

    const getAttendenceSummeryLists = async (month, year) => {
        if (month === undefined || year === undefined || month === '' || year === '') {
            return;
        }
        try {
            const daysInMonth = new Date(year, month, 0).getDate();
            const randomDay = Math.floor(Math.random() * daysInMonth) + 1;
            const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(randomDay).padStart(2, '0')}`;
            
            const URL = `/attendance/approve-attendance?date=${formattedDate}&page=${currentPage + 1}&pageSize=${rowsPerPage}&search=${searchQuery}`;
            const METHOD = "GET";

            const result = await fetchData({ url: URL, method: METHOD });

            const attendanceRecords = result?.data?.attendanceRecords || [];
            setAttendanceSummeryLists(attendanceRecords);

            const isAllApproved = attendanceRecords.every(record => record.is_approve);
            setIsApproved(isAllApproved);

            const totalPageCount = result?.data?.pagination?.totalPages || 1;
            setTotalPages(totalPageCount);
        } catch (error) {
            logger.log(error);
            openSnackbar({ message: "Error fetching attendance information", color: "danger" });
        }
    };

    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };

    const generateAttendance = async (month, year, isShow = false) => {
        if (month === undefined || year === undefined || month === '' || year === '') {
            return;
        }
        try {
            // const today = new Date().toISOString().split('T')[0];
            const daysInMonth = new Date(year, month, 0).getDate();
            const randomDay = Math.floor(Math.random() * daysInMonth) + 1;
            const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(randomDay).padStart(2, '0')}`;

            const URL = `/attendance/manual-attendance?date=${formattedDate}`;
            const METHOD = "GET";
            const result = await fetchData({ url: URL, method: METHOD });
            setIsViewButton(false)
            openSnackbar({ message: result.data, color: "success" });
            if(isShow){
                getAttendenceSummeryLists(month, year)
            }
        } catch (error) {
            logger.log(error);
            if (error.type === "GeneralError") {
                openSnackbar({ message: error.message, color: "danger" });
                setIsApproved(true)
                setIsViewButton(true)
                // getAttendenceSummeryLists(month, year)
            } else {
                openSnackbar({ message: "Error fetching generate attendace", color: "danger" });
            }
        }finally {
            // getAttendenceSummeryLists(month, year)
        }
    }
    const [buttonVisible, setButtonVisible] = useState(true);
    const approvedAttendance = async (month, year) => {
        try {
            // const today = new Date().toISOString().split('T')[0];
            const daysInMonth = new Date(year, month, 0).getDate();
            const randomDay = Math.floor(Math.random() * daysInMonth) + 1;
            const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(randomDay).padStart(2, '0')}`;

            const URL = `/attendance/approve-attendance`;
            const METHOD = "POST";

            const result = await fetchData({
                url: URL,
                method: METHOD,
                data: {
                    date: formattedDate
                }
            });

            openSnackbar({ message: result.data, color: "success" });
        } catch (error) {
            logger.log(error);
            if (error.type === "GeneralError") {
                openSnackbar({ message: error.message, color: "danger" });
            } else {
                openSnackbar({ message: "Error fetching generate attendace", color: "danger" });
            }
        } finally {
            getAttendenceSummeryLists(month, year);
            setButtonVisible(false);
        }
    }

    const deleteAttendance = async (month, year)=>{
        try {
            const daysInMonth = new Date(year, month, 0).getDate();
            const randomDay = Math.floor(Math.random() * daysInMonth) + 1;
            const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(randomDay).padStart(2, '0')}`;

            const URL = `/attendance/delete-approve-attendance?date=${formattedDate}`;
            const METHOD = "GET";

            const result = await fetchData({
                url: URL,
                method: METHOD,
            });

            openSnackbar({ message: result.data, color: "success" });
            return true;
        } catch (error) {
            if (error.type === "GeneralError") {
                openSnackbar({ message: error.message, color: "danger" });
            } else {
                openSnackbar({ message: "Error fetching generate attendace", color: "danger" });
            }
        } 
        finally {
            getAttendenceSummeryLists(month, year);
            setButtonVisible(true);

        }
    }

    useEffect(() => {
        getAttendenceSummeryLists(selectedMonth, selectedYear)
    }, [rowsPerPage, currentPage, searchQuery])

    useEffect(()=>{
        generateAttendance(selectedMonth,selectedYear)
    },[selectedMonth,selectedYear])

    return {
        getEmployeeData,
        exportToCSV,
        monthOptions,
        handleChoosenMonth,
        errorMessage,
        handleChoosenYear,
        yearOptions,
        uploadCSVData,
        attendanceSummeryLists,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        rowsPerPage,
        currentPage,
        totalPages,
        searchQuery,
        setSearchQuery,
        generateAttendance,
        approvedAttendance,
        buttonVisible,
        getAttendenceSummeryLists,
        deleteAttendance,
        count, setCount,
        isApproved,
        isViewButton,
        setAttendanceSummeryLists
    }
}

export default useAttendenceService;